import { useMemo } from 'react';

import type { DataTableCellOrColumnActions } from './user-actions-types.js';
import { useDataTable } from '../../contexts/DataTableContext.js';

/**
 * Unified hook to get the actions for 'cell' or 'header' contexts.
 * InlineUserActionsMenu consumes this one.
 */
export function useCellAndColumnActions(props: {
  enabled: boolean;
  headerGroupOrRowId: string;
  columnId: string;
  type: 'cell' | 'header';
}): DataTableCellOrColumnActions {
  const { enabled, columnId, headerGroupOrRowId, type } = props;
  const table = useDataTable();

  // Find the right column and cell objects to provide
  const actions = useMemo<DataTableCellOrColumnActions>(() => {
    if (enabled === false) {
      return null;
    }

    // header cell, get column actions
    if (type === 'header') {
      return table.getColumn(columnId)?.getColumnActions() ?? null;
    }

    // body cell, get cell actions
    if (headerGroupOrRowId) {
      const rowCells = table.getRow(headerGroupOrRowId).getAllCells();
      const cell = rowCells.find((cell) => cell.column.id === columnId);
      if (cell) {
        return cell?.getCellActions();
      }
    }

    return null;
  }, [columnId, enabled, headerGroupOrRowId, table, type]);

  return actions;
}
